import global_ from "../../global.config";
import request from "@/utils/request";
import Qs from 'qs';
// import Cookies from "js-cookie";
// import { MessageBox } from "mint-ui";
// import util from "@/utils/utils";
export function myLiveRoom(params) {
  return new Promise(function (resolve, reject) {
    request
      .post(`${global_.API_URL_LIVES}m/live/publicplatform/myLiveRoom?${Qs.stringify(params)}`, {})
      .then(function (data) {
        console.log("我的直播列表》》》》》》》》》》》》》》", data)
        resolve(data);
      });
  });
}
export function createLiveRoom(params) {
  return new Promise(function (resolve, reject) {
    request
      .post2(`${global_.API_URL_LIVES}m/live/publicplatform/createLiveRoom?${Qs.stringify(params)}`, {})
      .then(function (data) {
        console.log("创建直播间》》》》》》》》》》》》》》", data)
        resolve(data);
      });
  });
}
export function myLiveRoomByRoomId(roomId) {
  return new Promise(function (resolve, reject) {
    request
      .post2(`${global_.API_URL_LIVES}m/live/publicplatform/myLiveRoomByRoomId?roomId=${roomId}`, {

      })
      .then(function (data) {
        console.log("直播间信息》》》》》》》》》》》》》》", data)
        resolve(data);
      });
  });
}
export function cancelLiveRoom(roomId) {
  return new Promise(function (resolve, reject) {
    request
      .post(`${global_.API_URL_LIVES}m/live/publicplatform/cancelLiveRoom?roomId=${roomId}`, {
        //   roomId: roomId
      })
      .then(function (data) {
        console.log("取消直播间》》》》》》》》》》》》》》", data)
        resolve(data);
      });
  });
}
export function editLiveRoom(params) {
  return new Promise(function (resolve, reject) {
    request
      .post2(`${global_.API_URL_LIVES}m/live/publicplatform/editLiveRoom?${Qs.stringify(params)}`, {})
      .then(function (data) {
        console.log("编辑直播》》》》》》》》》》》》》》", data)
        resolve(data);
      });
  });
}
//预约直播
export function subscribe(roomId) {
  return new Promise(function (resolve, reject) {
    request
      .post(`${global_.API_URL_LIVES}m/live/rs/subscribe?roomId=${roomId}`, {
        //   roomId: roomId
      })
      .then(function (data) {
        console.log("预约直播》》》》》》》》》》》》》》", data)
        resolve(data);
      });
  });
}
export function getUserInfo(openid) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/global/User/getUserInfo",
        requestParam: {
          openid: openid
        }
      })
      .then(function (data) {
        // 此接口有没有授权注册都会返回obj的
        resolve(data);
      });
  });
}
//销售取消直播通知粉丝
export function sendMsgByCancel(roomId) {
  return new Promise(function (resolve, reject) {
    request
      .post(`${global_.API_URL_LIVES}m/live/rs/sendMsgByCancel?roomId=${roomId}`, {})
      .then((data) => {
        resolve(data)
      })
  })
}
//销售编辑直播通知粉丝
export function sendMsgByUpdate(roomId) {
  return new Promise(function (resolve, reject) {
    request
      .post(`${global_.API_URL_LIVES}m/live/rs/sendMsgByUpdate?roomId=${roomId}`, {})
      .then((data) => {
        resolve(data)
      })
  })
}
export function limitWxQRCodeWithCallbackUrl(appid, roomId, callbackurl) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/global/Qrcode/limitWxQRCodeWithCallbackUrl",
        requestParam: {
          appid: appid || "",
          respText: roomId,
          qrkey: 'livesubscribe',
          callbackurl: callbackurl || ""
        }
      })
      .then(function (data) {
        resolve(data)
      });
  })
}
//m/live/rs/promotionInfo
export function promotionInfo(roomId) {
  return new Promise(function (resolve, reject) {
    request
      .get(`${global_.API_URL_LIVES}m/live/rs/promotionInfo?roomId=${roomId}`, {})
      .then((data) => {
        resolve(data)
      })
  })
}
//  获取直播二维码m/live/publicplatform/getQRCode
export function getLiveQRCode(roomId, phone) {
  return new Promise(function (resolve, reject) {
    request
      .post(`${global_.API_URL_LIVES}m/live/publicplatform/getQRCode?roomId=${roomId}&phone=${phone}`, {})
      .then((data) => {
        resolve(data)
      })
  })
}